"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResults = getResults;
exports.questions = void 0;

var _sum2 = _interopRequireDefault(require("lodash/sum"));

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var batteryId = _utils.screeners.RTW_US_FEEDBACK;
var scale = ["0", "1", "2", "3", "4", "5"];
var baseProps = {
  batteryId: batteryId,
  extraText: ""
};
var feedbackQuestions = [{
  prompt: "How would you rate the program you just completed overall?",
  extraText: "",
  type: "slider",
  options: scale,
  eval: function _eval(n) {
    return n;
  }
}, {
  prompt: "How would you rate your experience with your coach?",
  extraText: "",
  type: "slider",
  options: scale,
  eval: function _eval(n) {
    return n;
  }
}, {
  prompt: "If we could change or improve anything about the program, what would it be?",
  type: "textarea",
  meta: {
    answerLabel: "",
    summaryTitle: "",
    placeholderText: ""
  }
}];
var questions = (0, _utils.wrapBattery)(feedbackQuestions, baseProps);
exports.questions = questions;

function getResults(answers) {
  return {
    RTW_FEEDBACK_1: answers[0],
    RTW_FEEDBACK_2: answers[1],
    RTW_FEEDBACK_3: answers[2]
  };
}